export default function unexpectedCallback(): never {
  throw new Error('Callback was not expected to be invoked.');
}
